import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Store } from '@ngrx/store';
import { selectIsLocationFieldBlacklisted } from '../../state/location-list-selectors';
import { Observable, switchMap } from 'rxjs';
import { LSCField } from '../../../../../models/LSCFields';
import { ICellRendererParams } from 'ag-grid-community';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';

interface MultiLineTextCellState extends AgCellState {}

export interface MultiLineTextCellComponentParams extends ICellRendererParams {
  splitSeparator: string,
  joinSeparator: string
}

@Injectable()
export class MultiLineTextCellLocalStoreService extends AgCellLocalStoreService<MultiLineTextCellState> {
  constructor(private store: Store, private locationGridStore: LocationListLocalStoreService) {
    super({
      cellValue: '',
      params: null});
  }

  readonly isFieldBlacklisted$ = this.params$.pipe(
      switchMap((params) =>
          this.store.select(selectIsLocationFieldBlacklisted(
              params.data?.id,
              (params.colDef?.field) as LSCField)
          )
      ));


  readonly viewModel$: Observable<{
    isFieldBlacklisted: boolean,
    value: string | string[],
    splitSeparator: string,
    joinSeparator: string,
    loading: boolean
  }> =
      this.select(this.isFieldBlacklisted$,
        this.cellValue$,
        this.params$,
        this.locationGridStore.loadingValues$,
          (isFieldBlacklisted, value, params, loadingValues) => {
            return {
              isFieldBlacklisted,
              value,
              splitSeparator: (params as MultiLineTextCellComponentParams).splitSeparator,
              joinSeparator: (params as MultiLineTextCellComponentParams).joinSeparator,
              loading: loadingValues[params?.data?.id]?.[params?.colDef?.field]
            }
          }
      );
}
